import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
    container: ({
        paddingSize,
    }: {
        paddingSize: 'none' | 'small' | 'medium' | 'large'
    }) => ({
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flexBasis: 'auto',
        padding:
            paddingSize === 'none'
                ? '0'
                : paddingSize === 'small'
                ? '1rem 2px'
                : paddingSize === 'large'
                ? '1rem 1.5rem'
                : '.7rem 1rem',
    }),
    containerOpen: ({
        paddingSize,
    }: {
        paddingSize: 'small' | 'medium' | 'large'
    }) => ({
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        flexBasis: 'auto',
        padding:
            paddingSize === 'small'
                ? '.1rem .1rem'
                : paddingSize === 'large'
                ? '1rem 1.5rem'
                : '.7rem 1rem',
    }),
    overflowHidden: {
        overflow: 'hidden',
    },
}))

interface ICardCell {
    overflowHidden?: boolean
    onClick?: () => void
    isOpen?: boolean
    paddingSize?: 'none' | 'small' | 'medium' | 'large'
}

const CardCell: React.FC<ICardCell> = ({
    overflowHidden,
    isOpen,
    onClick,
    children,
    paddingSize = 'medium',
}) => {
    const classes = useStyles({ paddingSize })

    return (
        <div
            className={`${isOpen ? classes.containerOpen : classes.container} ${
                overflowHidden ? classes.overflowHidden : ''
            }`}
            role="button"
            onClick={onClick && onClick}
            onKeyDown={onClick && onClick}
            tabIndex={-1}
        >
            {children}
        </div>
    )
}

CardCell.defaultProps = {
    overflowHidden: false,
}

export { CardCell }
